
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"2 min read","minutes":1.54,"time":92400,"words":308}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Docker image for ManageIQ is available. It can be run in a Docker container. There are also other options like `}<a parentName="p" {...{
        "href": "http://manageiq.org/docs/get-started/cloud"
      }}>{`Public cloud`}</a>{` or `}<a parentName="p" {...{
        "href": "http://manageiq.org/docs/get-started/vagrant"
      }}>{`Vagrant`}</a>{` to get started with ManageIQ. It can run everywhere Docker is available.`}</p>
    <p>{`First thing, you have to install Docker on your system. Follow instructions in `}<a parentName="p" {...{
        "href": "https://store.docker.com/search?type=edition&offering=community"
      }}>{`Docker docs`}</a>{` to install Docker.`}</p>
    <p>{`Start Docker service using`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo service docker start\n"
        }
      }}></code></pre>
    <p>{`or do`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "systemctl start docker\n"
        }
      }}></code></pre>
    <h2 {...{
      "id": "step-1-pull-docker-image-of-manageiq"
    }}>{`Step 1: Pull Docker image of ManageIQ`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker pull manageiq/manageiq\n"
        }
      }}></code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker pull manageiq/manageiq:gaprindashvili-4\n"
        }
      }}></code></pre>
    <p>{`It will download the ManageIQ image from the Docker registry. To see image list, run this`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker images ls\n"
        }
      }}></code></pre>
    <h2 {...{
      "id": "stpe-2-run-docker-container"
    }}>{`Stpe 2: Run Docker container`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker run --privileged -d -p 8443:443 manageiq/manageiq\n"
        }
      }}></code></pre>
    <p>{`or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker run --privileged -d -p 8443:443 manageiq/manageiq:gaprindashvili-4\n"
        }
      }}></code></pre>
    <p>{`It will run the container in detached mode. `}<inlineCode parentName="p">{`-p 8443:443`}</inlineCode>{` will forward your base machine’s `}<em parentName="p">{`8443`}</em>{` port requests to docker container’s `}<em parentName="p">{`443`}</em>{` port. To see a list of running containers, execute`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "sudo docker ps\n"
        }
      }}></code></pre>
    <p>{`Now ManageIQ container is up and running at IP address `}<a parentName="p" {...{
        "href": "https://127.0.0.1:8443"
      }}>{`https://127.0.0.1:8443`}</a></p>
    <p>{`It has a username as `}<em parentName="p">{`admin`}</em>{` and the password is `}<em parentName="p">{`smartvm`}</em>{`. Get the login and explore the world of ManageIQ.`}</p>
    <h2 {...{
      "id": "step-3-to-commit-the-changes-commit-the-container"
    }}>{`Step 3: To commit the changes Commit the container`}</h2>
    <p>{`It can be useful to commit a container’s file changes or settings into a new image. This allows you to debug a container by running an interactive shell or to export a working dataset to another server.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh",
        "data-language": "sh",
        "data-highlighted-line-numbers": "",
        "dangerouslySetInnerHTML": {
          "__html": "docker commit &quot;container_id&quot; manageiq\n"
        }
      }}></code></pre>
    <p>{`this saves all changes and data, next time run the `}<inlineCode parentName="p">{`manageiq`}</inlineCode>{` container.`}</p>
    <p>{`Reference: `}<a parentName="p" {...{
        "href": "http://manageiq.org/docs/get-started/docker"
      }}>{`http://manageiq.org/docs/get-started/docker`}</a></p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "step-1-pull-docker-image-of-manageiq",
    level: 2,
    title: "Step 1: Pull Docker image of ManageIQ",
    children: [
        
      ]
  },
{
    id: "stpe-2-run-docker-container",
    level: 2,
    title: "Stpe 2: Run Docker container",
    children: [
        
      ]
  },
{
    id: "step-3-to-commit-the-changes-commit-the-container",
    level: 2,
    title: "Step 3: To commit the changes Commit the container",
    children: [
        
      ]
  }
]

export const frontMatter = {
  "title": "ManageIQ Installation in Docker",
  "slug": "manage-iq-docker-installation",
  "subtitle": "",
  "author": "Saurabh Londhe",
  "banner": "Using-Docker-Containersposting.png",
  "bannerPlaceholder": "3-components-of-meaningful-motion-design-placeholder.jpg",
  "date": "2018-08-31T00:00:00.000Z",
  "categories": [
    "Project",
    "Linux",
    "Docker",
    "Cloud"
  ],
  "layout": "post"
}

